import { useContext, useEffect, useState } from "react";
import { desktopAppTaskContex } from "screen/desktop"
import userEvent from "@testing-library/user-event";
import { TaskInitParams } from "../../../model/taskObj";
import AppObj from "../../../model/appConfigObj";

export const DemoAppConfig = {
    appID:'demoApp',
    showName:'Demo Window',
    onList:true,
    icon:require('./images/terrarium_tv.png'),
    maxHead: 5,
    req:{
        minSize:{
            width:580,
            height:400
        },
        defSize:{
            width:580,
            height:420
        }
    }
  }

function DemoApp(props: {taskInitParms?:TaskInitParams[]}) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars 
  const [desktopControll] = useContext(desktopAppTaskContex);


  useEffect(() => {
    
    if(props.taskInitParms) { 
      props.taskInitParms.forEach(element => {
        if(element.command === 'passCount'){
          setCount(parseInt(element.value))
        }
      });
    }

    return () => {
    };
  }, []);

  const [count, setCount] = useState(0);
  return (
    <div  style={{backgroundColor:'#333333',height:"100%"}}>
        <div onClick={()=>setCount(pre=>pre+1)} style={{display:'flex',flexDirection:'column',justifyContent:'center', textAlign:'center', height:'100%',width:'100%',fontSize:'9em', color:'white'}}>
        <span style={{fontSize:40}}>Basic working apps example:</span>
          <span style={{}}>
            {count}
          </span>
          <span style={{fontSize:40}}>Click To Add</span>
        </div>
        <div style={{display:'flex',position:'absolute',bottom:0}}>
            <button style={{fontSize:18}} onClick={()=>desktopControll.openingTask('demoApp')}>New Window</button>
            <button style={{fontSize:18, borderRadius:'0 8px 0px 0px'}} onClick={()=>desktopControll.openingTask('demoApp', [{command:'passCount', value:count}])}>New Window (Passing Value)</button>
          </div>
    </div>
  )
}

const App:AppObj = {
  config : DemoAppConfig,
  body : DemoApp
}

export default App
